import { ActivatedRouteSnapshot } from '@angular/router';
import { inject } from '@angular/core';
import { SupplierContractWizardStore } from '../stores/supplier-contract-wizard.store';

export const supplierContractDraftLoadedGuard = async (route: ActivatedRouteSnapshot) => {
  const wizardStore = inject(SupplierContractWizardStore);
  const supplierContractId = route.paramMap.get('supplierContractId');
  if (!supplierContractId) {
    return false;
  }

  if (wizardStore.drafts().some((ei) => ei.id === supplierContractId)) {
    return true;
  }
  // We explicitly do not await the loading here to allow the router to proceed immediately.
  // This enables the target component to handle and display its own loading and error states,
  // providing a better user experience (e.g., showing skeletons instead of a blank screen).
  wizardStore.loadSingleDraft(supplierContractId);
  return true;
};
